import { render, staticRenderFns } from "./GlobalModalWrapper.vue?vue&type=template&id=5e2b378e&scoped=true"
import script from "./GlobalModalWrapper.vue?vue&type=script&lang=js"
export * from "./GlobalModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./GlobalModalWrapper.vue?vue&type=style&index=0&id=5e2b378e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b378e",
  null
  
)

export default component.exports